export const locales = ['en', 'es', 'pl', 'fr', 'pt', 'it', 'id', 'hi', 'ko', 'ru', 'de'] as const;
export const defaultLocale = 'en' as const;
export type Locale = (typeof locales)[number];
